import React from "react";
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import classNames from "classnames";
import ImageGallery from "react-image-gallery";
// import Datetime from "react-datetime";
import moment from 'moment';
import numeral from 'numeral';
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import Snackbar from '@material-ui/core/Snackbar';
import * as _ from 'lodash';

// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
// import InputLabel from "@material-ui/core/InputLabel";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import Tooltip from "@material-ui/core/Tooltip";

// react-dates Calendar dependencies
import {
    DateRangePicker,
    // SingleDatePicker, DayPickerRangeController
} from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

// import People from '@material-ui/icons/People';

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import Parallax from "../../components/Parallax/Parallax.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Accordion from "../../components/Accordion/Accordion.jsx";
// import InfoArea from "../../components/InfoArea/InfoArea.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import Card from "../../components/Card/Card.jsx";
// import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
// import CardFooter from "../../components/Card/CardFooter.jsx";
import InfoCardVEC from "../../components/common/InfoCardVEC";
import IconsServices from "../../components/common/IconsServices";

import SectionRooms from "./Sections/SectionRooms";
// import SectionMap from "./Sections/SectionMap";
import FooterSection from "../LandingPage/Sections/FooterSection";
import CustomNotification from "../LandingPage/Sections/CustomNotification";

import productStyle from "../../assets/jss/material-kit-pro-react/views/productStyle.jsx";

import calculateMaxPersonsRoom from "../../utils/calculateMaxPersonsRoom";
import calculateNumberOfDays from "../../utils/calculateNumberOfDays";
import isHighSeason from "../../utils/isHighSeason";
import { STATICS_URL } from "../../config/constants";
import { getAccommodation, filterRoomsAccommodation, clearAvailableRooms } from '../../actions/accommodationsActions';
import { IVA } from '../../config/constants';

import 'moment/locale/es'
moment.locale('es');

let fullLeasePrice = 0;
let fullLeaseHighSeason = null;
let fullLeaseNumberOfNights = 0;

class AccommodationDetailPage extends React.Component {
    /**
     * TODO: Añadir el logo del Alojamiento
     * TODO: En donde se va a añadir la calificacion del usuario?
     */
    constructor(props) {
        super(props);
        this.state = {
            openNotification: false,
            messageNotification: '',
            variantNotification: '',
            colorSelect: "0",
            sizeSelect: "0",
            startDate: null,
            endDate: null,
            maxBookableDate: null,
            minBookableDate: null,
            personsNumber: 1,
            float: null,
            filterButtonClicked: false,
            selectedRooms: [],
            maxPersonsInSelectedRooms: 0,
            totalPrice: 0,
            numberOfNights: 0,
            isHighSeason: null,
            maxPersonsLimit: null,
            errors: {}
        };
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    componentWillReceiveProps(newProps) {
        if (newProps.errors) {
            this.setState({ errors: newProps.errors });
        }
    };

    componentWillMount() {
        fullLeasePrice = 0;
        fullLeaseHighSeason = null;
        fullLeaseNumberOfNights = 0;

        this.clearFilteredRooms();

        this.props.getAccommodation(this.props.match.params.id);
        setTimeout(() => {
            !!this.props.accommodation.accommodation._id ? console.log() : this.props.history.goBack();
        }, 10000);

        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    };

    componentWillUpdate(props, state) {
        const { accommodation } = props.accommodation;
        const { startDate, endDate } = state;
        if (!!accommodation.full_lease && startDate!==null && endDate!==null){
            this.calculateFullLeasePrice(startDate, endDate);
        }
    }

    onChangeCustomInput = () => e => {
        this.setState({ [e.target.id]: e.target.value });
        this.clearFilteredRooms();
    };

    clearFilteredRooms = () => {
        this.setState({ selectedRooms:[], totalPrice:0, isHighSeason:null, numberOfNights:0, filterButtonClicked: false });
        this.props.clearAvailableRooms();
    };

    filterRooms = () => {
        const { accommodation } = this.props.accommodation;
        const { personsNumber, startDate, endDate } = this.state;

        this.setState({ filterButtonClicked: true });

        if (startDate!==null && endDate!==null) {
            if (personsNumber>=accommodation.min_persons && personsNumber<=accommodation.max_persons) {
                let filterData = {
                    accommodationId: accommodation._id,
                    start: this.state.startDate.format("DD/MM/YYYY"),
                    end: this.state.endDate.format("DD/MM/YYYY"),
                    persons: personsNumber
                };

                this.props.filterRoomsAccommodation(filterData);
                this.handleClickNotification('Habitaciones filtradas exitosamente', 'success');

            } else {
                this.handleClickNotification(`El número de huspedes admitido debe estar entre ${accommodation.min_persons} y ${accommodation.max_persons}`, 'warning');
            }
        } else {
            this.handleClickNotification('Por favor selecciona las fechas de Entrada y Salida', 'warning');
        }
    };

    addToList = (room) => {
        const { selectedRooms, totalPrice, startDate, endDate, personsNumber } = this.state;
        const { highSeason } = this.props.accommodation;

        if (_.find(selectedRooms, {_id: room._id})) {
            this.handleClickNotification('La habitacion seleccionada ya ha sido previamente añadida', 'warning');
        } else {

            let numberOfNights = calculateNumberOfDays(startDate, endDate);
            let maxPersonsNumber = calculateMaxPersonsRoom(room);
            this.setState({ maxPersonsInSelectedRooms: maxPersonsNumber });

            let auxTotalPrice;
            let auxRoomPrice;

            if (highSeason === true) {
                auxRoomPrice = (room.pricing.high_season * personsNumber * numberOfNights);
                auxTotalPrice = totalPrice + auxRoomPrice;
            } else {
                auxRoomPrice = (room.pricing.low_season * personsNumber * numberOfNights);
                auxTotalPrice = totalPrice + auxRoomPrice;
            }

            let auxSelectedRooms = selectedRooms;
            room.price = auxRoomPrice;
            auxSelectedRooms.push(room);
            this.setState({ selectedRooms: auxSelectedRooms, totalPrice: auxTotalPrice, numberOfNights, isHighSeason: highSeason });

            this.handleClickNotification('Habitacion añadida satisfactoriamente', 'success');
        }
    };

    calculateFullLeasePrice(startDate, endDate) {
        const { accommodation } = this.props.accommodation;
        fullLeaseHighSeason = isHighSeason(startDate, endDate);
        fullLeaseNumberOfNights = calculateNumberOfDays(startDate, endDate);

        if (fullLeaseHighSeason===true) {
            fullLeasePrice = (accommodation.pricing.high_season * fullLeaseNumberOfNights);
        } else {
            fullLeasePrice = (accommodation.pricing.low_season * fullLeaseNumberOfNights);
        }
    }

    goToBookingForm = () => {
        const { accommodation } = this.props.accommodation;
        const { authReducer } = this.props;
        const { selectedRooms, totalPrice, personsNumber, endDate, startDate } = this.state;

        if (!!accommodation.full_lease && accommodation.full_lease===true) {
            if (startDate!==null && endDate!==null) {

                let bookingInfo = {
                    full_lease: true,
                    start: startDate.format("DD/MM/YYYY"),
                    end: endDate.format("DD/MM/YYYY"),
                    accommodationId: accommodation._id,
                    accommodationName: accommodation.name,
                    accommodationCity: accommodation.location.city,
                    accommodationDepartment: accommodation.location.department,
                    persons: personsNumber,
                    tourist_id: authReducer.isAuthenticated ? authReducer.user._id : '',
                    totalPrice: fullLeasePrice,
                    tax: fullLeasePrice * IVA
                };

                localStorage.setItem('BOOKING_INFO', JSON.stringify(bookingInfo));
                this.props.history.push('/booking-accommodation');

            } else {
                this.handleClickNotification('Por favor selecciona las fechas de Entrada y Salida', 'warning');
            }

        } else {
            const roomsIds =  [];
            _.forEach(selectedRooms, function (selectedRoom) {
                roomsIds.push(selectedRoom._id);
            });

            let bookingInfo = {
                full_lease: false,
                start: startDate.format("DD/MM/YYYY"),
                end: endDate.format("DD/MM/YYYY"),
                accommodationId: accommodation._id,
                accommodationName: accommodation.name,
                accommodationCity: accommodation.location.city,
                accommodationDepartment: accommodation.location.department,
                persons: personsNumber,
                roomsInfo: selectedRooms,
                rooms: roomsIds, // Array of only Ids
                tourist_id: authReducer.isAuthenticated ? authReducer.user._id : '',
                totalPrice: totalPrice,
                tax: totalPrice * IVA
            };

            localStorage.setItem('BOOKING_INFO', JSON.stringify(bookingInfo));
            this.props.history.push('/booking-accommodation');
        }
    };

    render() {
        const { classes } = this.props;
        const { accommodation, availableRooms } = this.props.accommodation;
        const { selectedRooms } = this.state;

        const images = [];

        accommodation.photos.forEach(image => {
            if (image.is_360 === false) {
                images.push({
                    original: STATICS_URL+image.path,
                    thumbnail: STATICS_URL+image.path
                })
            }
        });

        return (
            <div className={classes.productPage+" "+classes.dashed}>
                {/* Custom Notification */}
                <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                    <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                </Snackbar>
                {/* End Custom Notification */}

                <Helmet>
                    <meta charSet="utf-8" />
                    {!!accommodation.name ? <title>{accommodation.name} | Vivamos el Campo - Turismo Rural</title> : null}
                    {!!accommodation._id ? <link rel="canonical" href={"https://vivamoselcampo.co/accommodation/"+accommodation._id} /> : null}
                    {!!accommodation.description ? <meta name="description" content={accommodation.description} /> : null}
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info"/>}
                    changeColorOnScroll={{
                        height: 130,
                        color: "white"
                    }}
                />
                <Parallax
                    image={require("../../assets/img/bg-accommodation-detail.jpg")}
                    filter="success"
                    className={classes.pageHeader}
                >
                </Parallax>
                <div className={classNames(classes.section, classes.sectionGray)}>
                    <div className={classes.container}>
                        <div className={classNames(classes.main, classes.mainRaised)}>
                            <GridContainer>
                                <GridItem md={8} sm={8} className={classes.dashed}>
                                    {images.length === 1 ?
                                        <img
                                            className={classNames( classes.imgRaised, classes.imgFluid, classes.rounded )}
                                            src={images[0].original}
                                            alt={accommodation.name}
                                        />
                                        :
                                        <ImageGallery
                                            showFullscreenButton={false}
                                            showPlayButton={false}
                                            startIndex={0}
                                            items={images}
                                            lazyLoad={true}
                                            showThumbnails={false}
                                            useBrowserFullscreen={true}
                                        />
                                    }
                                </GridItem>

                                <GridItem md={4} sm={4}>
                                    {isMobile ?
                                        <h3 className={classes.title}>{accommodation.name}</h3>
                                        :
                                        <h2 className={classes.title}>{accommodation.name}</h2>
                                    }
                                    <h5>{accommodation.location.city}, Colombia</h5>
                                    <ul className={classes.vecUlLeft}>
                                        {(!!accommodation.services && accommodation.services.length>0) ?
                                            accommodation.services.map( (serv, idx) => {
                                                return <IconsServices serv={serv} key={idx} tooltipClasses={classes.tooltip} />
                                            })
                                            :
                                            null
                                        }
                                    </ul>

                                    {!!accommodation.full_lease===true ?
                                        <p className={classes.vecFullLeaseAdv}>El Alojamiento se reserva en su totalidad</p>
                                        :
                                        null
                                    }
                                    {(!!accommodation.pricing && !!accommodation.pricing.high_season) ?
                                        <p className={classes.mainPriceMini}>COP$ {numeral(accommodation.pricing.high_season).format('0,0')} noche, Temp. Alta</p>
                                        :
                                        null}
                                    {(!!accommodation.pricing && !!accommodation.pricing.low_season) ?
                                        <p className={classes.mainPriceMini}>COP$ {numeral(accommodation.pricing.low_season).format('0,0')} noche, Temp. Baja</p>
                                        :
                                        null}

                                    <InfoCardVEC />
                                </GridItem>

                                <GridItem md={12} sm={12} className={classes.dashed}>

                                    <hr/>

                                    <GridContainer>
                                        <GridItem md={4} sm={12} xs={12} className={classes.dashed}>
                                            <FormControl
                                                fullWidth
                                                className={classes.selectFormControl}
                                            >
                                                {/* CheckIn DatePicker */}
                                                <DateRangePicker
                                                    numberOfMonths={1}
                                                    isOutsideRange={this.isBlocked}
                                                    startDate={this.state.startDate}
                                                    startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                                                    endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                                                    endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                                                    onDatesChange={({ startDate, endDate }) => {

                                                        this.clearFilteredRooms();
                                                        // In full_lease componentWillUpdate() will fired

                                                        let maxBookableDate = _.chain(accommodation.bookings).filter((d)=>{
                                                            return moment(d.start).isAfter(startDate, 'days');
                                                        }).orderBy((d)=>{ return moment(d.start);}).map('start').value();

                                                        this.setState({maxBookableDate: maxBookableDate[0]});
                                                        this.setState({ startDate, endDate });

                                                        let minBookableDate = _.chain(accommodation.bookings).filter((d)=>{
                                                            return moment(d.start).isBefore(startDate, 'days');
                                                        }).orderBy((d)=>{ return moment(d.end);}, ['desc']).map('end').value();

                                                        this.setState({minBookableDate: minBookableDate[0]});

                                                        this.setState({ startDate, endDate });

                                                    }} // PropTypes.func.isRequired,
                                                    focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                    onFocusChange={focusedInput => this.setState({ focusedInput })}
                                                    startDatePlaceholderText={"Llegada"}
                                                    endDatePlaceholderText={"Salida"}
                                                    displayFormat={'DD/MMM/YYYY'}
                                                    showClearDates={true}
                                                    hideKeyboardShortcutsPanel={true}
                                                    minimumNights={0}
                                                />
                                                {/* End CheckIn DatePicker */}
                                                <small>
                                                    {!!accommodation.full_lease===true ?
                                                        fullLeaseNumberOfNights
                                                        :
                                                        this.state.numberOfNights} noche(s) - COP${' '}

                                                    {!!accommodation.full_lease===true ?
                                                        numeral(fullLeasePrice).format('0,0')
                                                        :
                                                        numeral(this.state.totalPrice).format('0,0')
                                                    }

                                                    {fullLeaseHighSeason!==null || this.state.isHighSeason!==null ?
                                                        !!accommodation.full_lease ?
                                                            fullLeaseHighSeason===true ? " - Temporada Alta" : " - Temporada Baja"
                                                            :
                                                            this.state.isHighSeason===true ? " - Temporada Alta" : " - Temporada Baja"
                                                        :
                                                        null
                                                    }
                                                </small>
                                            </FormControl>
                                        </GridItem>

                                        <GridItem md={4} sm={12} xs={12} className={classes.dashed}>
                                            {!!accommodation.full_lease===true ?
                                                !!accommodation.max_persons ?
                                                    <GridContainer>
                                                        <GridItem md={12} sm={6} xs={6} className={classes.vecMaxPContainer+" "+classes.dashed}>
                                                            <p className={classes.vecLabel2}>Máx huéspedes permitido: {accommodation.max_persons}</p>
                                                        </GridItem>
                                                    </GridContainer>
                                                    :
                                                    null
                                                :
                                                <GridContainer>
                                                    <GridItem md={6} sm={6} xs={6} className={classes.vecMaxPContainer+" "+classes.dashed}>
                                                        <CustomInput
                                                            id="personsNumber"
                                                            formControlProps={{ fullWidth: true, className:classes.vecMaxPersInput }}
                                                            inputProps={{
                                                                type: "number",
                                                                defaultValue: this.state.personsNumber,
                                                                onChange: this.onChangeCustomInput(),
                                                                required: true
                                                            }}
                                                        />
                                                    </GridItem>
                                                    <GridItem md={6} sm={6} xs={6} className={classes.vecLabelContainer+" "+classes.dashed}>
                                                        <p className={classes.vecLabel}>Huesped(es) por Habitación</p>
                                                    </GridItem>
                                                </GridContainer>
                                            }
                                        </GridItem>

                                        <GridItem md={4} sm={12} xs={12} className={classes.dashed+" "+classes.vecButtonsContainer}>
                                            <GridContainer className={classes.dashed}>
                                                <GridItem md={6} sm={6} xs={6}>
                                                    {!!accommodation.full_lease ?
                                                        null
                                                        :
                                                        <Button fullWidth={true} onClick={this.filterRooms} color="success">
                                                            Filtrar
                                                        </Button>
                                                    }
                                                </GridItem>
                                                <GridItem md={6} sm={6} xs={6}>
                                                    {!!accommodation.full_lease ?
                                                        <Button fullWidth={true} onClick={this.goToBookingForm} color="success">
                                                            Reservar
                                                        </Button>
                                                        :
                                                        <Button fullWidth={true} onClick={this.goToBookingForm} disabled={!(selectedRooms.length>0)} color="success">
                                                            Reservar
                                                        </Button>
                                                    }
                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>
                                    </GridContainer>

                                    <hr/>

                                    {/* Room's Block */}
                                    {!!accommodation.full_lease===true ?
                                        null
                                        :
                                        <SectionRooms
                                            accommodation={accommodation}
                                            availableRooms={availableRooms}
                                            selectedRooms={selectedRooms}
                                            addToList={this.addToList}
                                            filterButtonClicked={this.state.filterButtonClicked}
                                        />
                                    }
                                    {/* End Room's Block */}

                                    <hr/>

                                    <Card className={classes.vecCardDetails}>
                                        <CardBody>
                                            <span><strong>Propietario: </strong>{accommodation.owner} <br/></span>
                                            {!!accommodation.RNT ? (<span><strong>Registro Nacional de Turismo: </strong>{accommodation.RNT} <br/></span>) : null}
                                            {(!!accommodation.rooms && accommodation.rooms.length>0) ?
                                                <span><strong>Total de habitaciones: </strong>{accommodation.rooms.length} <br/></span>
                                                :
                                                null
                                            }
                                        </CardBody>
                                    </Card>

                                    <Card className={classes.vecCardDetails}>
                                        <CardBody>
                                            { accommodation.description }
                                        </CardBody>
                                    </Card>

                                    <Accordion
                                        active={0}
                                        activeColor="success"
                                        collapses={[
                                            {
                                                title: "Políticas",
                                                content: (
                                                    <ul>
                                                        {!!accommodation.min_persons ? <li><strong>No. mínimo de huéspedes: </strong>{accommodation.min_persons}</li> : null}
                                                        {!!accommodation.max_persons ? <li><strong>No. máximo de huéspedes: </strong>{accommodation.max_persons}</li> : null}
                                                        {!!accommodation.check_in_hour ? <li><strong>Check-In. Hora llegada a partir de: </strong>{moment(accommodation.check_in_hour, "hh:mm").format("hh:mm a")}</li> : null}
                                                        {!!accommodation.check_out_hour ? <li><strong>Check-Out. Hora salida antes de: </strong>{moment(accommodation.check_out_hour, "hh:mm").format("hh:mm a")}</li> : null}
                                                        <li><strong>Se reciben mascotas: </strong>{accommodation.pets_allowed ? 'Sí' : 'No'}</li>
                                                        {!!accommodation.observations ? <li><strong>Otras observaciones: </strong>{accommodation.observations}</li> : null}
                                                    </ul>
                                                )
                                            },
                                            {
                                                title: "Localización",
                                                content: (
                                                    <div>
                                                        <ul>
                                                            <li><strong>País: </strong>Colombia</li>
                                                            <li><strong>Departamento: </strong>{accommodation.location.department}</li>
                                                            <li><strong>Municipio: </strong>{accommodation.location.city}</li>
                                                            {!!accommodation.location.address ? <li><strong>Dirección/Vereda: </strong>{accommodation.location.address}</li> : null}
                                                        </ul>

                                                        {/*<SectionMap location={accommodation.location} />*/}

                                                    </div>
                                                )
                                            },
                                            {
                                                title: "Sitios de Interés cercanos",
                                                content: (
                                                    <ul>
                                                        {(!!accommodation.interest_places && accommodation.interest_places.length>0) ?
                                                            accommodation.interest_places.map(place =>
                                                                <li key={place}>{place}</li>
                                                            )
                                                            : <li>No se han registrado destinos</li>}
                                                    </ul>
                                                )
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                        </div>
                    </div>
                </div>

                <FooterSection />
            </div>
        );
    };

    isBlocked = (day) => {
        const { accommodation } = this.props.accommodation;

        if (!!accommodation.full_lease) {
            if (!!this.state.maxBookableDate) {
                let isInFuture = day.startOf("day").isSameOrAfter(this.state.maxBookableDate, "day");
                let isInPast = day.startOf("day").isSameOrBefore(this.state.minBookableDate, "day");
                return isInFuture || isInPast;
            } else {

                for(let BLOCKED_RANGE of accommodation.bookings){
                    let range = BLOCKED_RANGE;
                    let isInRange = day.startOf("day").isBetween(range.start, range.end, "days", "[]");
                    let isInPast = day.startOf("day").isSameOrBefore(moment(), "day");

                    if(isInRange || isInPast){
                        return true;
                    }
                }
                return false;
            }
        } else {
            return day.startOf("day").isSameOrBefore(moment(), "day"); // Is in past
        }

    }
}

AccommodationDetailPage.propTypes = {
    getAccommodation: PropTypes.func.isRequired,
    filterRoomsAccommodation: PropTypes.func.isRequired,
    clearAvailableRooms: PropTypes.func.isRequired,
    authReducer: PropTypes.object.isRequired,
    accommodation: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    authReducer: state.authReducer,
    accommodation: state.accommodation
});

export default connect(mapStateToProps, { getAccommodation, filterRoomsAccommodation, clearAvailableRooms })( withStyles(productStyle)(AccommodationDetailPage) );



// WEBPACK FOOTER //
// ./src/views/AccommodationDetailPage/AccommodationDetailPage.jsx